var otp = {

    // Wires up a row of single-digit inputs: typing advances to the next field,
    // backspace walks back, and pasting (or SMS/password-manager autofill, which
    // arrives as one input event) spreads the digits over all fields.
    // Every change is reported to .NET as the joined code.
    init: (container, dotnet) => {
        const fields = Array.from(container.querySelectorAll('input'));
        const report = () => dotnet.invokeMethodAsync('SetCode', fields.map(f => f.value).join(''));

        const set = (field, value) => {
            field.value = value;
            field.dataset.prev = value;
        };

        const fill = (start, digits) => {
            let i = start;
            for (const d of digits) {
                if (i >= fields.length)
                    break;
                set(fields[i++], d);
            }
            fields[Math.min(i, fields.length - 1)].focus();
            report();
        };

        fields.forEach((field, index) => {
            field.addEventListener('input', () => {
                let digits = field.value.replace(/\D/g, '');
                // Typing into a filled field (caret not over the old digit) gives two
                // digits; keep only the new one instead of spilling into the next field.
                const prev = field.dataset.prev || '';
                if (prev && digits.length === 2 && digits.includes(prev))
                    digits = digits.replace(prev, '');
                set(field, '');
                if (digits.length)
                    fill(index, digits);
                else
                    report();
            });

            field.addEventListener('paste', e => {
                e.preventDefault();
                const digits = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
                if (digits.length)
                    fill(digits.length >= fields.length ? 0 : index, digits);
            });

            field.addEventListener('keydown', e => {
                if (e.key === 'Backspace' && !field.value && index > 0) {
                    e.preventDefault();
                    set(fields[index - 1], '');
                    fields[index - 1].focus();
                    report();
                } else if (e.key === 'ArrowLeft' && index > 0) {
                    e.preventDefault();
                    fields[index - 1].focus();
                } else if (e.key === 'ArrowRight' && index < fields.length - 1) {
                    e.preventDefault();
                    fields[index + 1].focus();
                }
            });

            field.addEventListener('focus', () => field.select());
        });

        fields[0].focus();
    },

    clear: container => {
        const fields = container.querySelectorAll('input');
        fields.forEach(f => { f.value = ''; f.dataset.prev = ''; });
        if (fields.length)
            fields[0].focus();
    }

};
